import { useDocumentTitle } from 'usehooks-ts';

import MinimalPageLayout from 'components/MinimalPageLayout';
import SignUpWithEmailForm from 'components/SignUpWithEmailForm';
import Link from 'ui/Link';
import { Text } from 'ui/Typography';
import { closePopupWindow } from 'utils/popup';
import { Path } from 'utils/routes';

const SignUpWithEmailPage: React.FC = () => {
  useDocumentTitle('Sign up to SankeyArt');
  return (
    <MinimalPageLayout.Root>
      <MinimalPageLayout.Content>
        <SignUpWithEmailForm onSuccess={closePopupWindow} />
      </MinimalPageLayout.Content>
      <MinimalPageLayout.Footer>
        <Text fontSize="sm" textAlign="center">
          Already have an account?{' '}
          <Link href={Path.SignInWithEmail}>Go to sign in.</Link>
        </Text>
      </MinimalPageLayout.Footer>
    </MinimalPageLayout.Root>
  );
};

export default SignUpWithEmailPage;
